// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"cc3e4c52","432":"35abaa8d","965":"c08d0097"}[chunkId] + ".chunk.js";
};